<template>
 <div>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card md="1" bg-variant="none"> {{description}}</b-card>
    </b-col>
    <b-col md="1">
    </b-col>
  </b-row>
  <br>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card bg-variant="light">
        <div v-if="showStorageSpaceSelection">
          <storage-space-select @selectedItems="setStorageSpaceId" :select_table_heading="showing_heading"/>
        </div>
        <ValidationObserver ref="observer">
          <b-form slot-scope="{ validate }" @submit.prevent="validate().then(callApi)">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Event Name:"
                  label-for="nested-event-name"
                  label-cols-sm="3"
                  label-align-sm="right"
                >
                  <b-form-input id="nested-event-name"
                    v-model="attr_copy['event-name']"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="Location:"
                    label-for="nested-location"
                    label-cols-sm="3"
                    label-align-sm="right"
                >
                  <b-form-input id="nested-location"
                    v-model="attr_copy['location']"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Zipcode:"
                  label-for="nested-zipcode"
                  label-cols-sm="3"
                  label-align-sm="right"
                >
                  <b-form-input id="nested-zipcode"
                    v-model="attr_copy.zipcode"
                    aria-describedby="input-zipcode-feedback"
                    :state="zipcodeState"
                    placeholder="Provide a zipcode"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-zipcode-feedback">
                    Enter a 5 digit zipcode
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Zip Ext:"
                  label-for="nested-zipext"
                  label-cols-sm="3"
                  label-align-sm="right"
                >
                  <b-form-input id="nested-zipext"
                    v-model="attr_copy.zipext"
                    aria-describedby="input-zipext-feedback"
                    :state="zipextState"
                    placeholder="Provide a zipcode ext"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <b-form-group
                  label="Access Permission:"
                  label-cols-sm="3"
                  label-align-sm="right"
                  class="mb-0"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                    class="pt-2"
                    :options="['private_access', 'protected_access', 'public_access']"
                    :aria-describedby="ariaDescribedby"
                    v-model="attr_copy['access-permission']"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="now:"
                  label-cols-sm="3"
                  label-align-sm="right"
                  class="mb-0"
                  v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox
                  v-model="attr_copy['is-happening']"
                  name="is-happening-check-button"
                  switch
                  :aria-describedby="ariaDescribedby"
                ></b-form-checkbox>
              </b-form-group>
              </b-col>
            </b-row>
            <div v-if="attr_copy">
              <p>Starts at {{display_scheduled_time_at}}</p>
              <p>Ends at {{display_ended_time_at}}</p>
            </div>
            <b-row>
              <b-col  md="6">
                <b-form-group
                  label="Scheduled Time At:"
                  label-for="nested-start-at"
                  label-cols-sm="3"
                  label-align-sm="right"
                >
                  <vc-date-picker mode="dateTime" locale="en-US" v-model="vc_scheduled_time_at" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Ended Time At:"
                  label-for="nested-end-at"
                  label-cols-sm="3"
                  label-align-sm="right"
                >
                  <!-- <b-calendar id="nested-end-at" v-model="attr_copy['end-at']" locale="en-US"></b-calendar> -->
                  <vc-date-picker mode="dateTime" locale="en-US" v-model="vc_ended_time_at" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
        <br>
      </b-card>
    </b-col>
    <b-col md="1">
      <data-operations
        :modified="modified"
        :can_update="canUpdate"
        :can_delete="canDelete"
        :can_help="canHelp"
        @update="doUpdate"
        @undo="doUndo"
        @delete="doDelete"
        @cancel="doCancel"
        @help="doHelp"
      ></data-operations>
    </b-col>
  </b-row>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import StorageSpaceSelect from './StorageSpaceSelect.vue'
import {amsMofifiedAttrs, localeStringOfUTC, deepEqual} from '@/utils'
import {amsSchema} from '@/schema'
import DataOperations from './DataOperations.vue'
import {isValidZipcode, isValidZipext} from '@/utils'
import { ValidationObserver } from 'vee-validate'
// import BFormInputDateTime from './BFormInputDateTime.vue'

export default {
  components: {
    StorageSpaceSelect,
    ValidationObserver,
    DataOperations,
    // BFormInputDateTime
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    },
  },
  data () {
    return {
      ams_type: 'showings',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      showing_heading: "Select collection for Showing",
      // selected: 'display_plan',
      // options: [
      //   { text: 'Plan', value: 'display_plan' },
      //   { text: 'Start', value: 'display_start' /*, disabled: true */ },
      //   { text: 'End', value: 'display_end'}
      // ],
      vc_scheduled_time_at: undefined,
      vc_ended_time_at: undefined
    }
  },
  computed: {
    zipcodeState() {
      return this.attr_copy.zipcode? (isValidZipcode(this.attr_copy.zipcode) ? true : false) : null
    },
    zipextState() {
      return this.attr_copy.zipext? (isValidZipext(this.attr_copy.zipext) ? true : false) : null
    },
    showStorageSpaceSelection() {
      return !(this.attr_copy['storage-space-id']?.length || this.attr_copy['storage-space-id'] > 0)
    },
    canUpdate() {
      return (
        this.attr_copy['storage-space-id']?.length > 0
        && this.attr_copy['storage-space-id'] > 0
        && this.attr_copy['start-at']?.length > 0
        && this.attr_copy['end-at']?.length > 0
        && this.attr_copy['location']?.length > 0
        && this.attr_copy['zipcode']?.length > 0
        && (this.attr_copy['event-name']?.length > 0)
      )
    },
    canDelete() {
      return false
    },
    canHelp() {
      return true
    },
    display_scheduled_time_at() {
      return localeStringOfUTC(this.attr_copy['start-at'])
    },
    display_ended_time_at() {
       return localeStringOfUTC(this.attr_copy['end-at'])
    }
  },
  methods: {
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$emit('noAction')
      if(this.reroute) {
        this.$router.go(-1)
      }
    },
    doDelete() {
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    setStorageSpaceId(items) {
      this.attr_copy['storage-space-id'] = items[0].id
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_')
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.post (
        this.apiResourcePath(), {
          ...attr_params
        }
      ).then(response => {
        if( response.data) {
         this.$store.dispatch('cached_products/add_product', response.data.data).then(() => {
          }).catch(() => {
          })
          this.$emit('takeAction')
          if(this.reroute) {
            this.$router.go(-1)
          }
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    callCancel() {
      this.$emit('noAction')
      if(this.reroute) {
        this.$router.go(-1)
      }
    }
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     },
     vc_scheduled_time_at(val) {
      this.attr_copy['start-at'] = val ? val.toISOString() : undefined
     },
     vc_ended_time_at(val) {
      this.attr_copy['end-at'] = val ? val.toISOString() : undefined
     }
  },
  mounted() {
    if(this.ams_template?.attributes) {
      this.attr_copy = {...this.ams_template.attributes}
    }
    else {
      const included_obj = amsSchema.find( 
        el =>  
        el.type === this.ams_type
      )
      this.attr_copy = {...included_obj.attributes}
    }
    this.description = this.ams_template?.description
  }
}
</script>